import { Provider, Type, inject, provideAppInitializer } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import {
  BaseSiteService,
  Config,
  ConfigInitializerService,
  CurrencyService,
  getContextParameterDefault,
  LanguageService,
  provideConfigValidator,
  SiteContext,
  SiteContextConfig
} from '@spartacus/core';
import { tap } from 'rxjs/operators';
import { SiteAdapter } from './connectors';
import {
  BASE_SITE_CONTEXT_ID,
  COUNTRY_CONTEXT_ID,
  CURRENCY_CONTEXT_ID,
  LANGUAGE_CONTEXT_ID,
} from './context-ids';
import { CountryInitializer } from './country-initializer';
import { CountryStatePersistenceService } from './country-state-persistence.service';
import { CountryService } from './country.service';
import { SiteContextConfigInitializer } from './site-context-config-initializer';
import { SiteContextParamsService } from './site-context-params.service';
import { SiteContextRoutesHandler } from './site-context-routes-handler';
import { SiteContextUrlSerializer } from './site-context-url-serializer';
import { StatePersistenceService } from './state-persistence.service';

export abstract class ContextServiceMap {
  [context: string]: Type<SiteContext<any>>;
}

export function serviceMapFactory() {
  return {
    [LANGUAGE_CONTEXT_ID]: LanguageService,
    [CURRENCY_CONTEXT_ID]: CurrencyService,
    [BASE_SITE_CONTEXT_ID]: BaseSiteService,
    [COUNTRY_CONTEXT_ID]: CountryService,
  };
}

export function initializeContext(
  configInit: ConfigInitializerService,
  siteContextRoutesHandler: SiteContextRoutesHandler
): () => Promise<Config> {
  return () => {
    return configInit
      .getStable('context')
      .pipe(tap(() => siteContextRoutesHandler.init()))
      .toPromise();
  };
}

export function initializeCountry(countryInitializer: CountryInitializer): () => void {
  const result = () => {
    countryInitializer.initialize();
  };
  return result;
}

export const contextServiceMapProvider: Provider = [
  {
    provide: ContextServiceMap,
    useFactory: serviceMapFactory,
  },
  provideAppInitializer(() => {
        const initializerFn = (initializeCountry)(inject(CountryInitializer));
        return initializerFn();
      }),
  provideConfigValidator(baseSiteConfigValidator),
  SiteContextUrlSerializer,
  SiteContextParamsService,
  CountryInitializer,
  CountryStatePersistenceService,
  StatePersistenceService,
  SiteContextRoutesHandler,
  SiteAdapter,
  { provide: UrlSerializer, useExisting: SiteContextUrlSerializer },
  provideAppInitializer(() => {
        const initializerFn = (initializeContext)(inject(ConfigInitializerService), inject(SiteContextRoutesHandler));
        return initializerFn();
      }),
  SiteContextConfigInitializer,
  BaseSiteService,
  LanguageService,
  CurrencyService,

];



export function baseSiteConfigValidator(config: SiteContextConfig) {
  if (getContextParameterDefault(config, BASE_SITE_CONTEXT_ID) === undefined) {
    return 'Please configure context.parameters.baseSite before using storefront library!';
  } else {
    return null;
  }
}
